import type {SliderOptionsRange} from '@Components/slider-options';

const BORDER_THICKNESS_MIN = 1;
const BORDER_THICKNESS_MAX = 100;
const LAYOUT_BORDER_THICKNESS_MAX = 10;

export const BORDER_THICKNESS_RANGE: SliderOptionsRange = {
  min: BORDER_THICKNESS_MIN,
  max: BORDER_THICKNESS_MAX,
};

export const LAYOUT_BORDER_THICKNESS_RANGE: SliderOptionsRange = {
  min: BORDER_THICKNESS_MIN,
  max: LAYOUT_BORDER_THICKNESS_MAX,
};
